import services from '../services/services';

export default {
  isLaborRequestAllowed: {
    paramNames: ['mustBeAlone', 'maxOccurrence'],
    validate: (value, { mustBeAlone, maxOccurrence }) =>
      services
        .isLaborRequestAllowed(value, mustBeAlone, maxOccurrence)
        .then(() => ({ valid: true }))
        .catch(msg => ({ valid: false, data: msg })),
    getMessage: (field, params, msg) => msg,
  },
  isLaborEvidenceAllowed: {
    validate: value =>
      services
        .isLaborEvidenceAllowed(value)
        .then(() => ({ valid: true }))
        .catch(msg => ({ valid: false, data: msg })),
    getMessage: (field, params, msg) => msg,
  },
  isIdAllowed: {
    validate: value =>
      services
        .isIdAllowed(value)
        .then(() => ({ valid: true }))
        .catch(msg => ({ valid: false, data: msg })),
    getMessage: (field, params, msg) => msg,
  },
};
